<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search"
                        :search-condition="searchCondition"
                        :hideFuzzySearch="true"
                        router-name="/content/download">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table ref="table"
                    :table-set="tableCondition"
                    :service-function="queryDownloadList"
                    :first-parameters="getInitParams()"
                    :is-first-automatic-visit="false"
                    router-name="/content/download">
      </custom-table>
    </div>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common/index';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { getMonthParams, initMonth } from '@/utils/tools/time';
import DownloadService from '@/views/content/api/download';

export default {
  components: {
    CustomTable,
    SearchComponent,
  },
  data() {
    return {
      dictionary: {},
      sourceFunctionList: [],
      fileStatusList: [],
      searchCondition: [
        {
          key: ['beginDateTime', 'endDateTime'],
          name: 'message.tableCommon.operationTime',
          defValue: initMonth(),
          type: 'date_time',
        },
      ],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.download.fileName' },
          key: 'fileName',
          type: 'text',
          itemMinWidth: 200,
        },
        {
          titleBar: { type: 'text', title: 'message.download.source' },
          key: 'source',
          type: 'text',
          itemMinWidth: 150,
          textFunc: (data) => getEnantiomericValue(this.sourceFunctionList, data.source),
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.operationTime' },
          key: 'dateTime',
          type: 'text',
          itemWidth: 180,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.operator' },
          key: 'operatorName',
          type: 'text',
          itemMinWidth: 120,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'fileStatus',
          type: 'text',
          itemWidth: 100,
          textFunc: (data) => getEnantiomericValue(this.fileStatusList, data.fileStatus),
        },
        {
          key: 'buttons',
          titleBar: { title: 'message.tableCommon.operation', type: 'operations' },
          type: 'operations',
          itemMinWidth: 120,
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.common.download',
              isDisplayFunc: (data) => (data.fileStatus === 'GS'),
              func: async (data) => {
                if (data.fileUrl) {
                  window.location.href = data.fileUrl;
                  await DownloadService.updateDownloadFlag({ fileId: data.id });
                  this.$store.dispatch('app/refreshDownloadTask');
                }
              },
            },
          ],
        },
      ],
    };
  },
  mounted() {
    getDictionary(['SOURCE_FUNCTION', 'FILE_STATUS']).then((res) => {
      this.sourceFunctionList = initSelectedData(res.SOURCE_FUNCTION);
      this.fileStatusList = initSelectedData(res.FILE_STATUS);
      this.$refs.table.firstVisitHttp();
    }).catch(() => ({}));
  },
  methods: {
    ...DownloadService,
    getInitParams() {
      const params = getMonthParams('beginDateTime', 'endDateTime');
      return params;
    },
  },
};
</script>
